import { render } from "./PushNotification.vue?vue&type=template&id=1d81e3aa&scoped=true"
import script from "./PushNotification.vue?vue&type=script&lang=js"
export * from "./PushNotification.vue?vue&type=script&lang=js"

import "./PushNotification.vue?vue&type=style&index=0&id=1d81e3aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d81e3aa"]])

export default __exports__